import { render, staticRenderFns } from "./AllClients.vue?vue&type=template&id=f71000a8&"
import script from "./AllClients.vue?vue&type=script&lang=js&"
export * from "./AllClients.vue?vue&type=script&lang=js&"
import style0 from "./AllClients.vue?vue&type=style&index=0&id=f71000a8&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f71000a8')) {
      api.createRecord('f71000a8', component.options)
    } else {
      api.reload('f71000a8', component.options)
    }
    module.hot.accept("./AllClients.vue?vue&type=template&id=f71000a8&", function () {
      api.rerender('f71000a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pages/AllClients.vue"
export default component.exports